function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// ./modules/components/g6_cnode.mjs
// ==================================================
// dependencies
import G6 from '@antv/g6';
// user defined
import * as g6_config from './g6_config.mjs';
// --------------------------------------------------
var ICON_MAP = {
  a: 'https://gw.alipayobjects.com/mdn/rms_8fd2eb/afts/img/A*0HC-SawWYUoAAAAAAAAAAABkARQnAQ',
  b: 'https://gw.alipayobjects.com/mdn/rms_8fd2eb/afts/img/A*sxK0RJ1UhNkAAAAAAAAAAABkARQnAQ'
};
// => variables
var rectConfig = g6_config.rectConfig;
var nodeOrigin = g6_config.nodeOrigin;
var textConfig = g6_config.textConfig;
var colorStatus = g6_config.colorStatus;
var colorJobType = g6_config.colorJobType;

// => personalizacion del nodo
var registerFn = function registerFn() {
  G6.registerNode('flow-rect', {
    draggable: true,
    shapeType: 'flow-rect',
    draw: function draw(cfg, group) {
      var id = cfg.id,
        label = cfg.label,
        name = cfg.name,
        collapsed = cfg.collapsed,
        status = cfg.status,
        job_type = cfg.job_type,
        company_code = cfg.company_code,
        zone_name = cfg.zone_name,
        job_technical_name = cfg.job_technical_name,
        creation_date = cfg.creation_date,
        flag_active = cfg.flag_active,
        id_object = cfg.id_object,
        project = cfg.project,
        dataset = cfg.dataset,
        source = cfg.source,
        objectType = cfg.objectType;
      var rect = group.addShape('rect', {
        attrs: _objectSpread({
          x: nodeOrigin.x,
          y: nodeOrigin.y
        }, rectConfig)
      });

      // > rectangular box item
      var rectBBox = rect.getBBox();

      // > label title
      var lab_title = "".concat(name);
      group.addShape('text', {
        attrs: _objectSpread(_objectSpread({}, textConfig), {}, {
          x: 12 + nodeOrigin.x,
          y: 20 + nodeOrigin.y,
          text: "".concat(lab_title.length > 28 ? lab_title.substr(0, 28) + '...' : lab_title),
          fontSize: 14,
          fill: '#000',
          opacity: 0.7,
          cursor: 'pointer'
        }),
        name: 'name-shape'
      });

      // > company_code
      var abrev = group.addShape('text', {
        attrs: _objectSpread(_objectSpread({}, textConfig), {}, {
          x: 12 + nodeOrigin.x,
          y: rectBBox.maxY - 10,
          text: "".concat(id_object),
          fontSize: 12,
          fill: '#000',
          opacity: 0.7
        })
      });

      // > company_code, name
      group.addShape('text', {
        attrs: _objectSpread(_objectSpread({}, textConfig), {}, {
          x: 12 + nodeOrigin.x,
          y: abrev.getBBox().maxY - rectConfig.height * 0.30,
          text: " ".concat(dataset),
          fontSize: 12,
          fill: '#000',
          opacity: 0.7
        })
      });
      group.addShape('text', {
        attrs: _objectSpread(_objectSpread({}, textConfig), {}, {
          x: 12 + nodeOrigin.x,
          y: abrev.getBBox().maxY - rectConfig.height * 0.30 + 20,
          text: " ".concat(source),
          fontSize: 12,
          fill: '#000',
          opacity: 0.7
        })
      });

      // > creation_date (optional)
      group.addShape('text', {
        attrs: _objectSpread(_objectSpread({}, textConfig), {}, {
          x: abrev.getBBox().maxX + 5,
          y: rectBBox.maxY - 12,
          //text: ` ${source}`,
          fontSize: 12,
          fill: '#000',
          opacity: 0.7
        })
      });

      // > job_code
      var percentText = group.addShape('text', {
        attrs: _objectSpread(_objectSpread({}, textConfig), {}, {
          x: rectBBox.maxX - 12,
          y: rectBBox.maxY - 12,
          text: "".concat(objectType),
          fontSize: 11,
          textAlign: 'right',
          fill: '#000',
          opacity: 0.7
        })
      });

      // > circle symbol --> status
      var symbol = collapsed ? 'circle' : 'square';
      var circle = group.addShape('marker', {
        attrs: _objectSpread(_objectSpread({}, textConfig), {}, {
          x: percentText.getBBox().minX - 10,
          y: rectBBox.maxY - 12 - 6,
          symbol: symbol,
          r: 6,
          fill: colorStatus[status]
        })
      });

      // > bottom rectangle (background) --> job_type
      var bottomRect = group.addShape('rect', {
        attrs: {
          x: nodeOrigin.x,
          y: rectBBox.maxY - 4,
          width: rectBBox.width - 1,
          height: 5,
          radius: [0, 0, rectConfig.radius, rectConfig.radius],
          fill: colorJobType[job_type]
        }
      });

      // > collapse rect
      if (cfg.children && cfg.children.length) {
        group.addShape('rect', {
          attrs: {
            x: rectConfig.width / 2 - 8,
            y: -8,
            width: 16,
            height: 16,
            stroke: 'rgba(0, 0, 0, 0.25)',
            cursor: 'pointer',
            fill: '#fff'
          },
          name: 'collapse-back',
          modelId: cfg.id
        });
        // >> collapse text
        group.addShape('text', {
          attrs: {
            x: rectConfig.width / 2,
            y: -1,
            textAlign: 'center',
            textBaseline: 'middle',
            text: collapsed ? '+' : '-',
            fontSize: 16,
            cursor: 'pointer',
            fill: 'rgba(0, 0, 0, 0.25)'
          },
          name: 'collapse-text',
          modelId: cfg.id
        });
      }
      this.drawLinkPoints(cfg, group);
      return rect;
    },
    update: function update(cfg, item) {
      var group = item.getContainer();
      this.updateLinkPoints(cfg, group);
    },
    setState: function setState(name, value, item) {
      if (name === 'collapse') {
        var group = item.getContainer();
        var collapseText = group.find(function (e) {
          return e.get('name') === 'collapse-text';
        });
        if (collapseText) {
          if (!value) {
            collapseText.attr({
              text: '-'
            });
          } else {
            collapseText.attr({
              text: '+'
            });
          }
        }
      }
    },
    getAnchorPoints: function getAnchorPoints() {
      return [[0, 0.5], [1, 0.5]];
    }
  }, 'rect');
  G6.registerNode('my-node', {
    drawShape: function drawShape(cfg, group) {
      var color = cfg.error ? '#e94235' : cfg.default ? '#5f6368' : '#1e8e3e';
      var r = 2;
      var shape = group.addShape('rect', {
        attrs: {
          x: -100,
          y: -0,
          width: 200,
          height: 50,
          stroke: color,
          radius: r
        },
        name: 'main-box',
        draggable: true
      });
      group.addShape('rect', {
        attrs: {
          x: -100,
          y: 0,
          width: 200,
          height: 20,
          fill: color,
          radius: [r, r, 0, 0]
        },
        name: 'title-box',
        draggable: true
      });

      // left icon
      group.addShape('image', {
        attrs: {
          x: -100,
          y: 2,
          height: 16,
          width: 16,
          cursor: 'pointer',
          img: ICON_MAP[cfg.nodeType || 'app']
        },
        name: 'node-icon'
      });

      // title text
      group.addShape('text', {
        attrs: {
          textBaseline: 'top',
          y: 4,
          x: -80,
          lineHeight: 20,
          text: cfg.title,
          fill: '#fff'
        },
        name: 'title'
      });

      // The content list
      // name text
      group.addShape('text', {
        attrs: {
          textBaseline: 'top',
          y: 30,
          x: -90,
          lineHeight: 20,
          text: cfg.description,
          fill: 'rgba(0,0,0, 0.4)'
        },
        name: "index-title-".concat(0)
      });
      return shape;
    }
  }, 'single-node');
};

// => exports
export { registerFn };